import { render, staticRenderFns } from "./softwareInfo.vue?vue&type=template&id=1abb8d68&"
import script from "./softwareInfo.vue?vue&type=script&lang=js&"
export * from "./softwareInfo.vue?vue&type=script&lang=js&"
import style0 from "./softwareInfo.vue?vue&type=style&index=0&id=1abb8d68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports